import React from 'react';
import { styled } from '@mui/system';
import Tooltip from '@mui/material/Tooltip';
import { isUndefinedOrNull, momentFormat } from '#helper';

const Container = styled('span')(() => ({
  minWidth: 24,
  whiteSpace: 'nowrap',
  '& svg': {
    verticalAlign: 'middle'
  },
  display: 'flex',
  alignItems: 'center'
}));

const NotAvailable = styled('span')(() => ({
  marginLeft: 2,
  opacity: 0.5
}));

function DashboardTemperature(props) {
  const {
    account,
    temperature
  } = props;
  const tooltip = !isUndefinedOrNull(temperature.value) ?
    `${temperature.description}. ${momentFormat(temperature.timestamp, account, 'dateTimePartial')}` :
    'No value within 7 days';
  return (
    <Tooltip title={tooltip} placement="top">
      {!isUndefinedOrNull(temperature.value) ?
        <Container>
          {temperature.value}
          {temperature.unit}
        </Container> :
        <NotAvailable>n/a</NotAvailable>}
    </Tooltip>
  );
}

export default DashboardTemperature;
